import * as yup from 'yup'

const hostnameRegex =
    /^(?:\*\.)?(?:[a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/

export const CreateReportSchema = yup.object().shape({
    provider: yup
        .string()
        .required('Provider là bắt buộc')
        .oneOf(['mlytics', 'conversant'], 'Provider không hợp lệ'),
    report_engine: yup
        .string()
        .required('Engine là bắt buộc')
        .oneOf(['v1', 'v2'], 'Engine không hợp lệ'),
    customer_id: yup
        .number()
        .required('Customer ID là bắt buộc')
        .positive('Customer ID phải là số dương')
        .integer('Customer ID phải là số nguyên'),
    customer_name: yup
        .string()
        .required('Tên khách hàng là bắt buộc')
        .max(255, 'Tên khách hàng không được vượt quá 255 ký tự'),
    priority: yup
        .number()
        .required('Độ ưu tiên là bắt buộc')
        .min(0, 'Độ ưu tiên phải từ 0 đến 10')
        .max(10, 'Độ ưu tiên phải từ 0 đến 10')
        .integer('Độ ưu tiên phải là số nguyên'),
    send_format: yup
        .string()
        .required('Định dạng gửi là bắt buộc')
        .oneOf(['default', 'DetailOriented'], 'Định dạng gửi không hợp lệ'),
    send_frequency: yup
        .string()
        .required('Tần suất gửi là bắt buộc')
        .oneOf(['weekly', 'monthly'], 'Tần suất gửi không hợp lệ'),
    status: yup
        .string()
        .required('Trạng thái là bắt buộc')
        .oneOf(['activate', 'deactivate'], 'Trạng thái không hợp lệ'),
    domain_source: yup
        .string()
        .required('Nguồn dữ liệu là bắt buộc')
        .oneOf(['elastic', 'history'], 'Nguồn dữ liệu không hợp lệ'),
    domains: yup
        .array()
        .of(
            yup
                .string()
                .matches(
                    hostnameRegex,
                    'Domain không hợp lệ (ví dụ: example.com hoặc *.example.com)'
                )
        )
        .optional(),
    service_customer_id: yup
        .string()
        .max(50, 'Service Customer ID không được vượt quá 50 ký tự')
        .optional(),
    service_id: yup
        .number()
        .typeError('Service ID phải là số')
        .integer('Service ID phải là số nguyên')
        .positive('Service ID phải là số dương')
        .nullable()
        .optional()
        // Cosmetic guard: submit handler is the definitive check.
        // _requireBinding is a hidden form field synced from onMeta.
        .test(
            'binding-required',
            'Vui lòng chọn service — khách hàng này có nhiều nhóm mailer nên phải gán service để gửi đúng người nhận.',
            function (value) {
                const { _requireBinding } = this.parent as {
                    _requireBinding?: boolean
                }
                if (_requireBinding && (value == null || value === undefined)) {
                    return false
                }
                return true
            }
        ),
    _requireBinding: yup.boolean().optional().default(false),
    description: yup.string().optional(),
})
